// extracted by mini-css-extract-plugin
export var spin = "progress-module--spin--sEWy-";
export var spinner = "progress-module--spinner--A6ODa";